// import React, { useState } from "react";
// import Modal from "react-modal";
// import { doc, updateDoc, getDoc } from "firebase/firestore";
// import { db } from "../../firebase/firebaseConfig";

// const FeedbackModal = ({ isOpen, onRequestClose, orderId, userId }) => {
//     const [feedback, setFeedback] = useState("");

//     const handleSubmit = async () => {
//         if (!feedback.trim()) return;

//         const userDocRef = doc(db, "users", userId);
//         const userDoc = await getDoc(userDocRef);

//         if (userDoc.exists()) {
//             const userData = userDoc.data();
//             const existingOrders = userData.orders || {};

//             await updateDoc(userDocRef, {
//                 [`orders.${orderId}.feedback`]: {
//                     comment: feedback,
//                     submittedAt: new Date().toISOString(),
//                 },
//             });

//             alert("✅ Feedback submitted successfully!");
//             setFeedback("");
//             onRequestClose();
//         }
//     };

//     return (
//         <Modal
//             isOpen={isOpen}
//             onRequestClose={onRequestClose}
//             style={{
//                 overlay: { backgroundColor: "rgba(0,0,0,0.5)" },
//                 content: { maxWidth: "500px", margin: "auto", borderRadius: "10px" },
//             }}
//         >
//             <h2>📝 Feedback for Order: {orderId}</h2>
//             <textarea
//                 rows={4}
//                 style={{ width: "100%", padding: "10px" }}
//                 placeholder="Write your feedback..."
//                 value={feedback}
//                 onChange={(e) => setFeedback(e.target.value)}
//             />
//             <div style={{ marginTop: "10px", textAlign: "right" }}>
//                 <button onClick={onRequestClose} style={{ marginRight: "10px" }}>
//                     Cancel
//                 </button>
//                 <button
//                     onClick={handleSubmit}
//                     style={{ backgroundColor: "#007bff", color: "#fff", padding: "8px 12px", borderRadius: "4px" }}
//                 >
//                     Submit
//                 </button>
//             </div>
//         </Modal>
//     );
// };

// export default FeedbackModal;

// import React, { useState, useEffect } from "react";
// import Modal from "react-modal";
// import { doc, updateDoc, getDoc } from "firebase/firestore";
// import { db, auth } from "../../firebase/firebaseConfig";
// import { collection, getDocs } from "firebase/firestore";

// const FeedbackModal = ({ isOpen, onRequestClose, darkMode }) => {
//     const [feedback, setFeedback] = useState("");
//     const [rating, setRating] = useState(0);
//     const [activeTab, setActiveTab] = useState("view"); // 'view' or 'submit'
//     const [allFeedbacks, setAllFeedbacks] = useState([]);
//     const [hasUnreviewedPurchase, setHasUnreviewedPurchase] = useState(false);

//     const handleSubmit = async () => {
//         if (!feedback.trim() || rating === 0) return;

//         try {
//             const user = auth.currentUser;
//             if (!user) {
//                 alert("Please login to submit feedback!");
//                 return;
//             }

//             const userDocRef = doc(db, "users", user.uid);
//             const userDoc = await getDoc(userDocRef);

//             if (userDoc.exists()) {
//                 const orders = userDoc.data().orders || {};

//                 // Find the most recent paid order
//                 const recentOrder = Object.values(orders)
//                     .filter(order => order.status === "paid")
//                     .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0];
//                 // console.log("User", user.displayName);
//                 if (recentOrder) {
//                     await updateDoc(userDocRef, {
//                         [`orders.${recentOrder.orderId}.feedback`]: {
//                             comment: feedback,
//                             rating: rating,
//                             submittedAt: new Date().toISOString(),
//                         },
//                     });

//                     alert("✅ Feedback submitted successfully!");
//                     setFeedback("");
//                     setRating(0);
//                     onRequestClose();
//                 } else {
//                     alert("No completed orders found to submit feedback for!");
//                 }
//             }
//         } catch (error) {
//             console.error("Error submitting feedback:", error);
//             alert("Failed to submit feedback. Please try again.");
//         }
//     };

//     // Fetch all feedbacks when component mounts
//     useEffect(() => {
//         const fetchAllFeedbacks = async () => {
//             try {
//                 const usersRef = collection(db, "users");
//                 const usersSnapshot = await getDocs(usersRef);

//                 const feedbacks = [];

//                 usersSnapshot.forEach(userDoc => {
//                     const orders = userDoc.data().orders || {};
//                     Object.values(orders).forEach(order => {
//                         if (order.feedback) {
//                             feedbacks.push({
//                                 ...order.feedback,
//                                 userId: userDoc.id,
//                                 orderId: order.orderId,
//                                 userName: order.name || "Anonymous", // Use stored name or default
//                                 createdAt: order.feedback.submittedAt || order.createdAt
//                             });
//                         }
//                     });
//                 });

//                 // Sort by date (newest first)
//                 feedbacks.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
//                 setAllFeedbacks(feedbacks);
//             } catch (error) {
//                 console.error("Error fetching feedbacks:", error);
//             }
//         };

//         fetchAllFeedbacks();
//     }, []);

//     useEffect(() => {
//         const checkForUnreviewedPurchases = async () => {
//             const user = auth.currentUser;
//             if (!user) return;

//             const userDoc = await getDoc(doc(db, "users", user.uid));
//             const orders = userDoc.data()?.orders || {};

//             // Find most recent paid order without feedback
//             const unreviewedOrder = Object.values(orders)
//                 .filter(order => order.status === "paid" && !order.feedback)
//                 .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0];
//             // console.log("Testing", unreviewedOrder);
//             if (unreviewedOrder) {
//                 setHasUnreviewedPurchase(true);
//                 setActiveTab("submit");
//             }
//         };

//         const delayTimeout = setTimeout(() => {
//             checkForUnreviewedPurchases();
//         }, 4500); // 4.5 seconds

//         return () => clearTimeout(delayTimeout); // Clean up timeout on unmount
//     }, []);


//     return (
//         <Modal
//             isOpen={isOpen || hasUnreviewedPurchase}
//             onRequestClose={() => { onRequestClose(); setHasUnreviewedPurchase(false) }}
//             style={{
//                 overlay: {
//                     backgroundColor: "rgba(0,0,0,0.5)",
//                 },
//                 content: {
//                     maxWidth: "500px",
//                     height: "70%",
//                     margin: "auto",
//                     borderRadius: "10px",
//                     background: darkMode ? "#333" : "#fff",
//                     color: darkMode ? "#fff" : "#333",
//                 },
//             }}
//         >
//             <div style={{
//                 display: "flex",
//                 borderBottom: `1px solid ${darkMode ? "#555" : "#ddd"}`,
//                 marginBottom: "20px"
//             }}>
//                 <button
//                     onClick={() => setActiveTab("view")}
//                     style={{
//                         padding: "10px",
//                         background: activeTab === "view" ? (darkMode ? "#444" : "#f0f0f0") : "transparent",
//                         border: "none",
//                         cursor: "pointer",
//                         fontWeight: activeTab === "view" ? "bold" : "normal",
//                         color: darkMode ? "#fff" : "#333"
//                     }}
//                 >
//                     View Feedback
//                 </button>
//                 {auth.currentUser && <button
//                     onClick={() => setActiveTab("submit")}
//                     style={{
//                         padding: "10px",
//                         background: activeTab === "submit" ? (darkMode ? "#444" : "#f0f0f0") : "transparent",
//                         border: "none",
//                         cursor: "pointer",
//                         fontWeight: activeTab === "submit" ? "bold" : "normal",
//                         color: darkMode ? "#fff" : "#333"
//                     }}
//                 >
//                     Submit Feedback
//                 </button>}
//             </div>

//             {activeTab === "view" ? (
//                 <div>
//                     <h2 style={{ marginBottom: "15px" }}>Customer Feedback</h2>
//                     {allFeedbacks.length === 0 ? (
//                         <p>{!auth.currentUser ? "Please LOGIN to see the comments." : "No feedback available yet."}</p>
//                     ) : (
//                         <div style={{ maxHeight: "400px", overflowY: "auto" }}>
//                             {allFeedbacks.map((fb, index) => (
//                                 <div
//                                     key={index}
//                                     style={{
//                                         padding: "15px",
//                                         marginBottom: "15px",
//                                         background: darkMode ? "#444" : "#f5f5f5",
//                                         borderRadius: "8px"
//                                     }}
//                                 >
//                                     <span style={{ fontWeight: "bold" }}>
//                                         {fb.userName}
//                                     </span>
//                                     <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
//                                         <div style={{ color: "#ffc107" }}>
//                                             {'★'.repeat(fb.rating || 0)}{'☆'.repeat(5 - (fb.rating || 0))}
//                                         </div>
//                                         <span style={{
//                                             marginLeft: "10px",
//                                             fontSize: "0.8rem",
//                                             color: darkMode ? "#aaa" : "#666"
//                                         }}>
//                                             {/* {new Date(fb.submittedAt || fb.createdAt).toLocaleString()} */}
//                                             {new Date(fb.submittedAt || fb.createdAt).toLocaleDateString('en-US', {
//                                                 year: 'numeric',
//                                                 month: 'short',
//                                                 day: 'numeric'
//                                             })}
//                                         </span>
//                                     </div>
//                                     <p>{fb.comment}</p>
//                                 </div>
//                             ))}
//                         </div>
//                     )}
//                     <button
//                         onClick={() => { onRequestClose(); setHasUnreviewedPurchase(false) }}
//                         style={{
//                             position: "absolute",
//                             bottom: "10px",
//                             marginRight: "10px",
//                             padding: "8px 16px",
//                             background: "#6c757d",
//                             color: "#fff",
//                             border: "none",
//                             borderRadius: "4px",
//                             cursor: "pointer"
//                         }}
//                     >
//                         Close
//                     </button>
//                 </div>
//             ) : (
//                 <div>
//                     <h2 style={{ marginBottom: "15px" }}>Please Submit Your Feedback For Your Last Purchase.</h2>
//                     <div style={{ marginBottom: "15px" }}>
//                         <label style={{ display: "block", marginBottom: "5px" }}>Rating:</label>
//                         <div style={{ display: "flex", gap: "5px" }}>
//                             {[1, 2, 3, 4, 5].map((star) => (
//                                 <span
//                                     key={star}
//                                     style={{
//                                         cursor: "pointer",
//                                         fontSize: "24px",
//                                         color: rating >= star ? "#ffc107" : (darkMode ? "#555" : "#ddd")
//                                     }}
//                                     onClick={() => setRating(star)}
//                                 >
//                                     ★
//                                 </span>
//                             ))}
//                         </div>
//                     </div>
//                     <textarea
//                         rows={4}
//                         style={{
//                             width: "90%",
//                             padding: "10px",
//                             margin: "15px",
//                             background: darkMode ? "#444" : "#f5f5f5",
//                             color: darkMode ? "#fff" : "#333",
//                             border: `1px solid ${darkMode ? "#555" : "#ddd"}`
//                         }}
//                         placeholder="Write your feedback..."
//                         value={feedback}
//                         onChange={(e) => setFeedback(e.target.value)}
//                     />
//                     <div style={{ textAlign: "right" }}>
//                         <button
//                             onClick={() => { onRequestClose(); setHasUnreviewedPurchase(false) }}
//                             style={{
//                                 marginRight: "10px",
//                                 padding: "8px 16px",
//                                 background: "#6c757d",
//                                 color: "#fff",
//                                 border: "none",
//                                 borderRadius: "4px",
//                                 cursor: "pointer"
//                             }}
//                         >
//                             Close
//                         </button>
//                         <button
//                             onClick={handleSubmit}
//                             disabled={!feedback.trim() || rating === 0}
//                             style={{
//                                 padding: "8px 16px",
//                                 background: (!feedback.trim() || rating === 0) ? "#cccccc" : "#28a745",
//                                 color: "#fff",
//                                 border: "none",
//                                 borderRadius: "4px",
//                                 cursor: (!feedback.trim() || rating === 0) ? "not-allowed" : "pointer"
//                             }}
//                         >
//                             Submit
//                         </button>
//                     </div>
//                 </div>
//             )}
//         </Modal>
//     );
// };

// export default FeedbackModal;

import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { doc, updateDoc, getDoc, collection, getDocs } from "firebase/firestore";
import { db, auth } from "../../firebase/firebaseConfig";

const FeedbackModal = ({ isOpen, onRequestClose, darkMode }) => {
    const [feedback, setFeedback] = useState("");
    const [rating, setRating] = useState(0);
    const [activeTab, setActiveTab] = useState("view");
    const [allFeedbacks, setAllFeedbacks] = useState([]);

    const user = auth.currentUser;

    // Fetch all feedbacks once
    useEffect(() => {
        const fetchAllFeedbacks = async () => {
            try {
                const usersRef = collection(db, "users");
                const usersSnapshot = await getDocs(usersRef);

                const feedbacks = [];
                usersSnapshot.forEach((userDoc) => {
                    const orders = userDoc.data().orders || {};
                    Object.values(orders).forEach((order) => {
                        if (order.feedback) {
                            feedbacks.push({
                                ...order.feedback,
                                userId: userDoc.id,
                                orderId: order.orderId,
                                userName: order.name || "Anonymous",
                                createdAt: order.feedback.submittedAt || order.createdAt
                            });
                        }
                    });
                });

                feedbacks.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
                setAllFeedbacks(feedbacks);
            } catch (error) {
                console.error("Error fetching feedbacks:", error);
            }
        };

        fetchAllFeedbacks();
    }, []);

    const handleSubmit = async () => {
        if (!feedback.trim() || rating === 0) return;
        if (!user) {
            alert("Please login to submit feedback!");
            return;
        }

        try {
            const userDocRef = doc(db, "users", user.uid);
            const userDoc = await getDoc(userDocRef);
            const orders = userDoc.data().orders || {};

            const recentOrder = Object.values(orders)
                .filter(order => order.status === "paid")
                .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0];

            if (!recentOrder) {
                alert("No completed orders found to submit feedback!");
                return;
            }

            await updateDoc(userDocRef, {
                [`orders.${recentOrder.orderId}.feedback`]: {
                    comment: feedback,
                    rating: rating,
                    submittedAt: new Date().toISOString(),
                },
            });

            alert("✅ Feedback submitted successfully!");
            setFeedback("");
            setRating(0);
            onRequestClose();

        } catch (error) {
            console.error(error);
            alert("Failed to submit feedback. Please try again.");
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            style={{
                overlay: { backgroundColor: "rgba(0,0,0,0.5)" },
                content: {
                    maxWidth: "500px",
                    height: "70%",
                    margin: "auto",
                    borderRadius: "10px",
                    background: darkMode ? "#333" : "#fff",
                    color: darkMode ? "#fff" : "#333",
                },
            }}
        >
            {/* Tabs */}
            <div style={{ display: "flex", borderBottom: `1px solid ${darkMode ? "#555" : "#ddd"}`, marginBottom: "20px" }}>
                <button
                    onClick={() => setActiveTab("view")}
                    style={{
                        padding: "10px",
                        background: activeTab === "view" ? (darkMode ? "#444" : "#f0f0f0") : "transparent",
                        border: "none",
                        cursor: "pointer",
                        fontWeight: activeTab === "view" ? "bold" : "normal",
                        color: darkMode ? "#fff" : "#333"
                    }}
                >
                    View Feedback
                </button>
                {user && (
                    <button
                        onClick={() => setActiveTab("submit")}
                        style={{
                            padding: "10px",
                            background: activeTab === "submit" ? (darkMode ? "#444" : "#f0f0f0") : "transparent",
                            border: "none",
                            cursor: "pointer",
                            fontWeight: activeTab === "submit" ? "bold" : "normal",
                            color: darkMode ? "#fff" : "#333"
                        }}
                    >
                        Submit Feedback
                    </button>
                )}
            </div>

            {activeTab === "view" ? (
                <div>
                    <h2 style={{ marginBottom: "15px" }}>Customer Feedback</h2>
                    {allFeedbacks.length === 0 ? (
                        <p>{!user ? "Please LOGIN to see the comments." : "No feedback available yet."}</p>
                    ) : (
                        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                            {allFeedbacks.map((fb, i) => (
                                <div key={i} style={{ padding: "15px", marginBottom: "15px", background: darkMode ? "#444" : "#f5f5f5", borderRadius: "8px" }}>
                                    <span style={{ fontWeight: "bold" }}>{fb.userName}</span>
                                    <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                                        <div style={{ color: "#ffc107" }}>{'★'.repeat(fb.rating || 0)}{'☆'.repeat(5 - (fb.rating || 0))}</div>
                                        <span style={{ marginLeft: "10px", fontSize: "0.8rem", color: darkMode ? "#aaa" : "#666" }}>
                                            {new Date(fb.submittedAt || fb.createdAt).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}
                                        </span>
                                    </div>
                                    <p>{fb.comment}</p>
                                </div>
                            ))}
                        </div>
                    )}
                    <button onClick={onRequestClose} style={{ position: "absolute", bottom: "10px", marginRight: "10px", padding: "8px 16px", background: "#6c757d", color: "#fff", border: "none", borderRadius: "4px", cursor: "pointer" }}>Close</button>
                </div>
            ) : (
                <div>
                    <h2 style={{ marginBottom: "15px" }}>Submit Your Feedback</h2>
                    <div style={{ marginBottom: "15px" }}>
                        <label style={{ display: "block", marginBottom: "5px" }}>Rating:</label>
                        <div style={{ display: "flex", gap: "5px" }}>
                            {[1, 2, 3, 4, 5].map(star => (
                                <span key={star} style={{ cursor: "pointer", fontSize: "24px", color: rating >= star ? "#ffc107" : (darkMode ? "#555" : "#ddd") }} onClick={() => setRating(star)}>★</span>
                            ))}
                        </div>
                    </div>
                    <textarea rows={4} style={{ width: "90%", padding: "10px", margin: "15px", background: darkMode ? "#444" : "#f5f5f5", color: darkMode ? "#fff" : "#333", border: `1px solid ${darkMode ? "#555" : "#ddd"}` }} placeholder="Write your feedback..." value={feedback} onChange={(e) => setFeedback(e.target.value)} />
                    <div style={{ textAlign: "right" }}>
                        <button onClick={onRequestClose} style={{ marginRight: "10px", padding: "8px 16px", background: "#6c757d", color: "#fff", border: "none", borderRadius: "4px", cursor: "pointer" }}>Close</button>
                        <button onClick={handleSubmit} disabled={!feedback.trim() || rating === 0} style={{ padding: "8px 16px", background: (!feedback.trim() || rating === 0) ? "#cccccc" : "#28a745", color: "#fff", border: "none", borderRadius: "4px", cursor: (!feedback.trim() || rating === 0) ? "not-allowed" : "pointer" }}>Submit</button>
                    </div>
                </div>
            )}
        </Modal>
    );
};

export default FeedbackModal;
